// Where a dragged block lands, from the pointer and the rectangles on screen (spec 3.9). A flow
// is { axis: 'row' | 'vertical', reversed, canWrap }; zones are before, after, row-start,
// row-end, stack-start and stack-end, each with the edge its highlight line goes on.

const SIDE_BAND_SHARE = 0.2;
const MIN_SIDE_BAND = 16;
const MAX_SIDE_BAND = 48;
const STACK_BAND_SHARE = 0.25;
const MAX_STACK_BAND = 32;

function clamp(value, minimum, maximum) {
  return Math.min(Math.max(value, minimum), maximum);
}

// The first half of the target in reading order inserts before it; reversed flows swap them.
function orderZone(isFirstHalf, reversed) {

  if (isFirstHalf !== reversed) {
    return 'before';
  }

  return 'after';

}

function findVerticalZone(rectangle, point, flow) {

  const band = clamp(rectangle.width * SIDE_BAND_SHARE, MIN_SIDE_BAND, MAX_SIDE_BAND);

  if (flow.canWrap === true && point.x < rectangle.left + band) {
    return { zone: 'row-start', edge: 'left' };
  }

  if (flow.canWrap === true && point.x > rectangle.right - band) {
    return { zone: 'row-end', edge: 'right' };
  }

  if (point.y < rectangle.top + rectangle.height / 2) {
    return { zone: orderZone(true, flow.reversed), edge: 'top' };
  }

  return { zone: orderZone(false, flow.reversed), edge: 'bottom' };

}

function findRowZone(rectangle, point, flow) {

  const band = Math.min(rectangle.height * STACK_BAND_SHARE, MAX_STACK_BAND);

  if (flow.canWrap === true && point.y < rectangle.top + band) {
    return { zone: 'stack-start', edge: 'top' };
  }

  if (flow.canWrap === true && point.y > rectangle.bottom - band) {
    return { zone: 'stack-end', edge: 'bottom' };
  }

  if (point.x < rectangle.left + rectangle.width / 2) {
    return { zone: orderZone(true, flow.reversed), edge: 'left' };
  }

  return { zone: orderZone(false, flow.reversed), edge: 'right' };

}

export function findTargetZone(rectangle, point, flow) {

  if (flow.axis === 'row') {
    return findRowZone(rectangle, point, flow);
  }

  return findVerticalZone(rectangle, point, flow);

}
